const types = {
  CREATE_PHOTO_SERIES_SUCCESS: '@drivex/photoSeries/GET_SELECTED_WORKFLOW_SUCCESS',
  UPDATE_WINDSHIELD_REPAIR_REPLACE_DECISION: '@drivex/photoseries/UPDATE_WINDSHIELD_REPAIR_REPLACE_DECISION',
  UPDATE_AUTOMATED_WINDSHIELD_CALCULATION_IN_PROGRESS: '@drivex/photoseries/UPDATE_AUTOMATED_WINDSHIELD_CALCULATION_IN_PROGRESS'
};

export { types };
